import React, { Component } from 'react';
/*import { useParams } from 'react-router-dom'*/
import { Data } from '../Data';

export class AccountActivation extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
		this.performAccountActivation = this.performAccountActivation.bind(this);		
    }

    performAccountActivation() {
       
        let url = window.location.search;
        console.log({ url });

        const arr = url.slice(1).split(/&|=/); // remove the "?", "&" and "="

        for (let i = 0; i < arr.length; i += 2) {
            const key = arr[i], value = arr[i + 1];
            if ((key === 'id') && value) {
                this.dataService.performAccountActivation(value);
            }
        }
    };

    render() {
        return (
            <div>{this.performAccountActivation()}
            </div>
        )
	}
}
